import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { AsyncTasksDto } from '../core/models/async-tasks.dto'
import { AsyncTasksItemComponent } from './async-task-item/async-tasks-item.component'
import { MatButtonModule } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'async-tasks',
  template: `
    <div class="container">
      <div class="async-tasks-title">{{ 'ASYNC_TASKS.TITLE' | translate }}</div>
      @for (task of tasks; track task.id) {
        <async-task-item
          [task]="task"
          (ackEvent)="ackEvent.emit($event)"
        ></async-task-item>
      }
      <div class="close-btn-wrapper">
        <button
          mat-raised-button
          class="close-btn"
          color="primary"
          type="button"
          (click)="closeTasksList.emit()"
        >
          {{ 'GENERAL.HIDE' | translate }}
        </button>
      </div>
    </div>
  `,
  styleUrls: ['async-tasks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncTasksItemComponent, MatButtonModule, TranslatePipe],
})
export class AsyncTasksContainerComponent {
  @Input({ required: true }) tasks: AsyncTasksDto[]
  @Output() closeTasksList = new EventEmitter<void>()
  @Output() ackEvent = new EventEmitter<AsyncTasksDto>()
}
